module.exports = __webpack_public_path__ + "img/video-cover-sell.59e8d63f.png";